import { MenuService } from './../../services/menu.service';
import { Component, OnInit } from '@angular/core';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';

@Component({
  selector: 'app-student-messages',
  templateUrl: './student-messages.component.html',
  styleUrls: ['./student-messages.component.scss']
})
export class StudentMessagesComponent implements OnInit {
  isEdit = false;
  currentPageId;
  hidden = true;
  messageData: any;
  currentStudentProfileId = '';
  constructor(
    private _menuService: MenuService,
    private draggableModalService: DraggableModalService) { }

  ngOnInit() {
    this.getPageData();
  }
  getPageData() {
    this.currentPageId = this._menuService.getCurrentPageId();
  }

  toggleComposeBox(resetJson) {
    this.isEdit = resetJson.isEdit;
    this.messageData = resetJson.messageData || resetJson;
    const baseId = `modal-student-message`;
    const header = this.isEdit ? 'Reply to coach' : 'New message for coach';
    const id = `${baseId}-${this.isEdit ? 'reply' : 'new'}`;
    const modal = this.draggableModalService.show({
      id,
      baseId,
      trayTitle: header,
      class: 'message-modal',
      width: 660,
      initialState: {
        attachments: [],
        modalId: id,
        header: header,
        messageData: Object.assign({}, this.messageData),
        isEdit: this.isEdit,
        currentStudentProfileId: this.currentStudentProfileId
      }
    });
    if (this.isEdit) {
      modal.content.updateFormData();
    }
  }
}
